// AnimatedText.js
import React from "react";
import '../styles/Textanimation.css';
import { useInView } from "react-intersection-observer";
// import styles from "../../styles/AnimatedText.module.css";
const AnimatedText9 = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once when it first comes into view
    threshold: 0.1,    // trigger when 10% of the component is in view
  });
  return (
    <div ref={ref} className={`container ${inView ? "animate" : ""}`}>
      <div className="text a"> But, </div>
      <div className="text b"> why </div>
      <div className="text c"> would  </div>
      <div className="text d"> you </div>
      <div className="text e"> want </div>
      <div className="text f"> to </div>
      <div className="text g"> work </div>
      <div className="text h"> with </div>
      <div className="text i"> us? </div>
    </div>
  );
};
export default AnimatedText9;